import DataServiceSQL from "../DataService/DataServiceSQL";
import React, {useState} from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const UpdateStaffAnonymity = (props) => {
    const [submitted, setsubmitted] = useState(false);
    const [anonymised, setAnonymised] = useState(Boolean(props.anonymity));
    const [displayButtons, setDisplayButtons] = useState(true);
    const [message, setmessage] = useState( <FormattedMessage id="staff.edit" defaultMessage="Edit staff" /> );
    const { classes } = props;

    const handleAnonChange = async () => {
      setAnonymised(!anonymised)
    };

    const UpdateAnonymity = async () => {
        var data = {
          "resourceType" : "Practitioner",
          "anonymity": anonymised
        }
        await (DataServiceSQL.updatePractitionnerReq_fhir(props.id, data))
          .then((response) => {
            setmessage( <FormattedMessage id="message.success" defaultMessage="Success!" /> );
            setsubmitted(true);
          })
          .catch((e) => {
            console.log(e);
          });
    };

    return (
        <div className={classes.popup_background}>
          <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <div className="submit-form">
              {submitted ? (
                <div>
                  <center>
                  <h1>{message}</h1>
                  <button onClick={props.closeAfterUpdate} className="btn btn-success">
                    <FormattedMessage id="button.close" defaultMessage="Close" />
                  </button>
                  </center>
                </div>
              )
              :
              (
                <div>
                  <center>
                    <h1>{message}</h1>
                    <div>
                      <input type="checkbox" id="checkbox_anonimity" name="anonymity" onChange={handleAnonChange} defaultChecked={props.anonymity}></input>
                      <label for="anonymity_label">Anonymity</label>
                    </div>
                    {displayButtons ? (
                      <div>
                        <button onClick={props.cancelPopup} className="btn btn-danger">
                          <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                        </button>
                        <b>&emsp;</b>
                        <button onClick={() => UpdateAnonymity()} className="btn btn-success">
                          <FormattedMessage id="button.submit" defaultMessage="Submit" />
                        </button> 
                      </div>
                    )
                    :
                    null
                    }
                  </center>
                </div>
              )}
            </div>
          </div>
        </div>
    );
};
export default withStyles(Constants.styles)(UpdateStaffAnonymity);